(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('PasswordResetFinish', function ($resource) {
            return $resource('api/account/reset_password/finish', {}, {});
        });

})();
